import { lazy } from 'react';

import { RouteObject } from '@/types/router';

import { LazyLoad } from '../utils/lazy-load';

export default [
  {
    path: '/bill',
    children: [
      {
        path: 'coin',
        children: [
          {
            index: true,
            element: LazyLoad(lazy(() => import('@/pages/bill/coin'))),
          },
        ],
      },
      {
        path: 'bean',
        children: [
          {
            index: true,
            element: LazyLoad(lazy(() => import('@/pages/bill/bean'))),
          },
        ],
      },
      {
        path: 'coffee',
        children: [
          {
            index: true,
            element: LazyLoad(lazy(() => import('@/pages/bill/coffee'))),
          },
        ],
      },
      {
        path: 'gem',
        children: [
          {
            index: true,
            element: LazyLoad(lazy(() => import('@/pages/bill/gem'))),
          },
        ],
      },
      {
        path: 'pearl',
        children: [
          {
            index: true,
            element: LazyLoad(lazy(() => import('@/pages/bill/pearl'))),
          },
        ],
      },
    ],
  },
] as RouteObject[];
